import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import { MdOutlineSwapHoriz } from "react-icons/md";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useNavigate } from "react-router-dom";
import ProductModalContent from "./ModalContent/ProductModalContent";
import { useProductList } from "./hooks/useProductCatalogue";
import { useGetOrgUnitsData } from "../Employee/hooks/useEmployee";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import { BASE_URL } from "../../Api/config";
 
const HeaderContent = (props: any) => {
  const handleFilter = (key: any, selected: any) => {
    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));
  };
 
  return (
    <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={props?.orgUnitsList || []}
        onSelect={(e) => handleFilter("orgUnits", e)}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Org Unit"
        headingColor="#2e8dd3"
      />
    </div>
  );
};
 
const Products = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<any>(null);
  const [mode, setMode] = useState<"add" | "edit" | "view">("add");
  const [productId, setProductId] = useState();
  const getEmptyProduct = () => ({
  ProductName: "",
  ProductDescription: "",
  PackingQty: "",
  PackingDesc: "",
  ProductSku: "",
  BasePrice: "",
  orgUnits: "",
  Brand: null,
  Category: "",
  Tag: "",
  PackingType: "",
});
 
 
  const [filtersState, setFiltersState] = useState<any>({
    orgUnits: null,
    limit: 10,
    page: 1,
    search: null,
  });
  const [disable,setDisabled] = useState<boolean>(false);
 
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
 
  const ProductList = useProductList({
    enable: true,
    params: {
      Orgunitid: filtersState.orgUnits,
      length: filtersState.limit,
      start: filtersState.page,
      // search: filtersState.search ?? "",
      ...(filtersState.search ==""?{}:{search: filtersState.search})
    },
  });
 
  const navigate = useNavigate();
 
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setSelectedBrand(null);
  };
 
 const handleAddClick = () => {
  setMode("add");
  setProductId(undefined);   // 🔑 reset productId so no fetch happens
  setSelectedBrand(getEmptyProduct()); // always start clean
  setIsModalOpen(true);
};
 
  const handleEditClick = (product: any) => {
    setSelectedBrand(product);
    setProductId(product.id);
    setIsModalOpen(true);
    setMode("edit");
  };
 
const handleClose = () => {
  setIsModalOpen(false);
  setSelectedBrand(null);
  setProductId(undefined);   // 🔑 clear productId
};
 
  const handleManageClick = (brand: any) => {
    navigate(`/catalogue/products/productlistbybrand`, { state: { brand } });
  };
 
  const productDataColumns = [
    {
      name: "Org Unit",
      selector: (row: any) => row.orgunit,
      sortable: true,
      width: "130px",
    },
    {
      name: "Brand",
      selector: (row: any) => row.brand,
      sortable: true,
      width: "130px",
    },
    {
      name: "Category",
      selector: (row: any) => row.category,
      sortable: true,
      width: "130px",
    },
    {
      name: "Product Name",
      selector: (row: any) => row.productname,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: "SKU",
      selector: (row: any) => row.sku,
      sortable: true,
      width: "150px",
    },
    {
      name: "Unit",
      selector: (row: any) => row.unit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Price",
      selector: (row: any) => row.price,
      sortable: true,
      width: "120px",
    },
    {
      name: "Created on",
      selector: (row: any) => row.created,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: "Modified on",
      selector: (row: any) => row.modified ||'-',
      sortable: true,
      width: "140px",
      wrap: true,
    },
    {
      name: "Action",
      width: "200px",
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
          <button
            onClick={() => handleEditClick(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
          </button>
          <button
            onClick={() => handleManageClick(row)}
            className="btn d-flex align-items-center justify-content-center gap-1"
            style={{
              backgroundColor: "#2e8dd3",
              color: "white",
              borderRadius: "20px",
              padding: "4px",
              width: "100px",
              border: "none",
            }}
          >
            <MdOutlineSwapHoriz size={20} style={{ fill: "#fff" }} /> Manage
          </button>
        </div>
      ),
    },
  ];
 
  type ApiProductItem = {
    Id: number;
    OrgunitId: number;
    BrandName: string;
    CategoryName: string;
    ProductName: string;
    ProductSku: string;
    UnitCode: string;
    BasePrice: string | number;
    CreatedAt: string;
    UpdatedAt: string;
    [key: string]: any;
  };
 
  type FormattedProductItem = {
    id: number;
    orgunit: number;
    brand: string;
    category: string;
    productname: string;
    sku: string;
    unit: string;
    price: string | number;
    created: string;
    modified: string;
  };
 
  function formatProductData(data: ApiProductItem[]): FormattedProductItem[] {
    return data.map((item) => ({
      id: item.Id,
      orgunit: item.UnitName,
      brand: item.BrandName,
      category: item.CategoryName,
      productname: item.ProductName,
      sku: item.ProductSku,
      unit: item.UnitCode,
      price: item.BasePrice,
      created: item.CreatedAt.split(' ')[0],
      modified: item.UpdatedAt != null ? item.UpdatedAt.split(' ')[0] : item.UpdatedAt,
    }));
  }
 
  const FormattedData = Array.isArray(ProductList.data?.data?.data)
    ? formatProductData(ProductList.data?.data?.data)
    : [];
 
  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };
 
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleDownLoad = async(fileType:string)=>{
    const appToken = localStorage.getItem('Apptoken') || ''
    const params:Record<string,any>={
      ...(filtersState.orgUnit === null?{}:{Orgunitid:filtersState.orgUnit}),
      ...(filtersState.search === null ?{}:{search:filtersState.search})
    }
    const queryString = new URLSearchParams(params).toString(); 
    const apiEndpoint =`${BASE_URL}admin/api/getProductsExcel?${queryString}`
    const fileName = 'Product.xlsx'

    try{
       setDisabled(true);
       const response = await downloadExcelGet({apiEndpoint,appToken,fileName}) 
        
       if(response.success){
          setDisabled(false);
       }
    }catch(error:any){
       console.log('Error While downloading Product excel');
    }finally{
       setDisabled(false);
    }
  }

 
  return (
    <div className="p-2">
      <PageHeader
        title="Products"
        buttons={[
          {
            label: "+ Add Products",
            onClick: handleAddClick,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () =>handleDownLoad('excel'),
            color:disable?"#888" : "#43B9B2",
            disable:disable
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />
 
      <BasicDataTable
        dynamicHeightOnRowsPerPage={true}
        paginationTotalRows={ProductList?.data?.data?.recordsTotal}
        Title="Product list"
        data={FormattedData}
        columns={productDataColumns}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        headerContent={
          <div style={{marginRight:10}}>
          <HeaderContent
            orgUnitsList={orgUnitsList?.data}
            setFiltersState={setFiltersState}
            />

          </div>
        }
      />
    
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={mode == "add" ? "Add Product" : "Edit Product"}
        size="lg"
        content={
          <ProductModalContent
            mode={mode}
            selectedBrand={selectedBrand || {}}
            setSelectedBrand={setSelectedBrand}
            handleClose={handleClose}
            ProductID={productId}
          />
        }
      />
      </div>
  );
};
 
export default Products;